export interface Formation {
  diploma: string;
  field: string;
  institution: string;
  location: string;
  year: string;
  status: "en cours" | "obtenu";
  highlights?: string[];
}

export const formations: Formation[] = [
  {
    diploma: "Master 1 Informatique",
    field: "Développement web et applications",
    institution: "Université Lumière Lyon 2 (ICOM) — Portes des Alpes",
    location: "Lyon, France",
    year: "2026 - Aujourd'hui",
    status: "en cours",
    highlights: [
      "Spécialisation en développement web et applications",
      "Approfondissement des architectures logicielles modernes",
      "Projets avancés en équipe",
      "Approche recherche et innovation",
    ],
  },
  {
    diploma: "BUT (Bachelor Universitaire de Technologie) Informatique",
    field: "Parcours Développement d'applications",
    institution: "IUT d'Annecy",
    location: "Annecy, France",
    year: "2025 - 2026",
    status: "obtenu",
    highlights: [
      "Formation complète en développement web et logiciel",
      "Projets pratiques en équipe avec des technologies modernes",
      "Approche professionnelle du développement",
      "Parcours Développement d'applications",
    ],
  },
  {
    diploma: "BTS SIO (Services Informatiques aux Organisations)",
    field: "SLAM (Solutions Logicielles et Applications Métiers)",
    institution: "Lycée Gabriel Fauré",
    location: "Annecy, France",
    year: "2023 - 2025",
    status: "obtenu",
    highlights: [
      "Spécialisation en développement d'applications",
      "Maîtrise des technologies web modernes",
      "Gestion de projets informatiques",
      "Expérience en développement full-stack",
    ],
  },
  {
    diploma: "Baccalauréat Professionnel Gestion et Administration",
    field: "Gestion et Administration",
    institution: "Lycée Sainte Famille",
    location: "La Roche sur Foron, France",
    year: "2020 - 2023",
    status: "obtenu",
    highlights: [
      "Bases solides en gestion administrative",
      "Compétences en organisation et planification",
      "Maîtrise des outils de gestion de comptabilité",
      "Expérience en relation client",
    ],
  },
  {
    diploma: "Brevet",
    field: "Diplôme National du Brevet",
    institution: "Collège Sainte Marie",
    location: "La Roche sur Foron, France",
    year: "2020",
    status: "obtenu",
    highlights: [
      "Premier diplôme obtenu avec mention Assez Bien",
      "Bases solides en mathématiques et sciences",
      "Développement de l'autonomie et de la rigueur",
    ],
  },
];
